import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CardContainerBaseComponent } from '@resident-nx/shared';

@Component({
  selector: 'rs-web-cards-container',
  templateUrl: './cards-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cards-container.component.scss'],
})
export class CardsContainerWebComponent extends CardContainerBaseComponent {}
